const SHOP_BASE_URL = window.__SHOP_BASE_URL__ || ''

// 跳转电商相关页面
export const goShopPages = (path: string, openType: string = 'self') => {
  if (openType === 'new') {
    window.open(`${SHOP_BASE_URL}${path}`, '_blank')
  } else {
    window.location.href = `${SHOP_BASE_URL}${path}`
  }
}
